import { utils } from '@noble/secp256k1';
export var randomBytes = function randomBytes() {
  var bytesLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
  return utils.randomBytes(bytesLength);
};